import { IAnalyticsScorecard } from '@/types/analytics';
import { Get } from '../helpers';
import filterParams from './filter-params';

const GetEventUniqueAttendance = ({
  projectUuid,
  start,
  end,
  audienceLists,
  signal,
}: {
  projectUuid: string;
  start?: number;
  end?: number;
  audienceLists?: string[];
  signal?: AbortSignal;
}): Promise<IAnalyticsScorecard | null> => {
  return Get({
    path: `/v3/admin/metrics/events/${projectUuid}/unique-attendance?${filterParams({ start, end, audienceLists })}`,
    signal,
    isMetrics: true,
  });
};

export default GetEventUniqueAttendance;
